import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Coin_Listing from "../../../../images/icon/Coin_Listing.png";

const API_KEY = "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9";

const DEFINITIONS = [
  { key: "balance", title: "Main Wallet", icon: "fa-solid fa-wallet", money: true },
  { key: "investing_wallet", title: "Trade Amount", icon: "fa-solid fa-chart-line", money: true },
  /*{ key: "reserve_balance", title: "Deposit Wallet", icon: "fa-solid fa-vault", money: true, precision: 4 },
  { key: "investing_node", title: "Count Node", image: Coin_Listing },
  { key: "daily_return", title: "Invest Return", icon: "fa-solid fa-arrow-trend-up" },
  { key: "refer_inc", title: "Refer Bonus", icon: "fa-solid fa-gift", money: true },*/
  { key: "coin_gen", title: "Invest Generation", icon: "fa-solid fa-coins", money: true },
  { key: "coin_reserve", title: "Global Elite Pool", icon: "fa-solid fa-vault", money: true },
  /*{ key: "bord_earning", title: "Bord Earning", icon: "fa-solid fa-sack-dollar", money: true },*/
  { key: "leadership_bonus", title: "IB Income", icon: "fa-solid fa-crown", money: true },
  { key: "rank_income", title: "Monthly Salary", icon: "fa-solid fa-medal", money: true },
  /*{ key: "total_deposit", title: "Total Deposit", icon: "fa-solid fa-money-bill-transfer", money: true },*/
  { key: "total_Income", title: "Total Income", icon: "fa-solid fa-circle-dollar-to-slot", money: true },
  { key: "total_withdraw", title: "Total Withdrawal", icon: "fa-solid fa-arrow-up-from-bracket", money: true },
];

const displayValue = (value, money, precision) => {
  const raw = value === null || value === undefined || value === "" ? 0 : value;
  if (precision !== undefined) {
    const parsed = Number(raw);
    return `${money ? "$" : ""}${Number.isFinite(parsed) ? Number(parsed.toFixed(precision)) : 0}`;
  }
  return `${money ? "$" : ""}${raw}`;
};

const Home = () => {
  const [homeData, setHomeData] = useState({});
  const [apiError, setApiError] = useState(false);

  useEffect(() => {
    document.title = "RM-CrownMarket Home";
    const controller = new AbortController();
    let active = true;

    const fetchData = async () => {
      try {
        const response = await axios.post("/home-data", { key_s: API_KEY }, { signal: controller.signal });
        if (!active) return;
        setHomeData(response?.data?.data_info || {});
        setApiError(false);
      } catch (error) {
        if (active && error?.code !== "ERR_CANCELED") {
          setApiError(true);
          console.error("Asset overview request failed:", error);
        }
      }
    };

    fetchData();
    const interval = window.setInterval(fetchData, 70000000);
    return () => {
      active = false;
      controller.abort();
      window.clearInterval(interval);
    };
  }, []);

  const cards = useMemo(() => DEFINITIONS.map((item) => ({
    ...item,
    value: displayValue(homeData[item.key], item.money, item.precision),
  })), [homeData]);

  return (
    <>
      <style>{`
        html, body, #root { background: #00191D !important; }
        body { margin: 0; }
        .rm-assets, .rm-assets * { box-sizing: border-box; }
        .rm-assets { --navy:#00191D; --cyan:#16B8C7; --muted:#a5c0c5; background:#00191D; color:#fff; min-height:100vh; width:100%; padding:14px 4px 32px; font-size:14px; line-height:1.45; }
        .rm-assets__head { display:flex; justify-content:space-between; align-items:center; gap:12px; padding:20px; margin-bottom:12px; border-radius:18px; background:linear-gradient(115deg,#07333a,#00191D); border:1px solid #18505a; }
        .rm-assets__eyebrow { margin:0 0 5px; color:#72e3e8; font-size:12px; font-weight:700; letter-spacing:.07em; text-transform:uppercase; }
        .rm-assets__heading { margin:0; font-size:clamp(20px,2.6vw,27px); font-weight:800; color:#fff; }
        .rm-assets__sub { margin:6px 0 0; color:#a5c0c5; font-size:14px; }
        .rm-assets__head-icon { display:grid; place-items:center; width:52px; height:52px; flex-shrink:0; border-radius:15px; background:linear-gradient(135deg,#16B8C7,#0b778a); color:#fff; font-size:21px; }
        .rm-assets__intro { display:flex; justify-content:space-between; align-items:center; gap:10px; padding:12px 16px; margin-bottom:12px; background:#fff; border-radius:14px; color:#12333a; }
        .rm-assets__intro strong { font-size:14px; }
        .rm-assets__intro span { font-size:12px; color:#51727a; }
        .rm-assets__grid { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:12px; }
        .rm-assets__card { position:relative; display:flex; align-items:center; gap:13px; min-width:0; min-height:116px; padding:18px; border-radius:16px; border:1px solid #20515a; background:#06262c; color:#fff; transition:transform .2s ease,border-color .2s ease; animation:rmAssetAppear .35s ease both; }
        .rm-assets__card:nth-child(4n+2), .rm-assets__card:nth-child(4n+3) { background:#fff; border-color:#d9e7e9; color:#102c33; }
        .rm-assets__card:hover { transform:translateY(-3px); border-color:#16B8C7; }
        .rm-assets__icon { display:grid; place-items:center; flex:0 0 46px; width:46px; height:46px; border-radius:13px; background:linear-gradient(135deg,#16B8C7,#087b8d); color:#fff; font-size:19px; }
        .rm-assets__icon img { width:27px; height:27px; object-fit:contain; }
        .rm-assets__details { min-width:0; }
        .rm-assets__label { font-size:13px; opacity:.76; margin:0 0 5px; }
        .rm-assets__value { margin:0; font-size:clamp(16px,1.7vw,22px); line-height:1.25; font-weight:800; overflow-wrap:anywhere; font-variant-numeric:tabular-nums; }
        .rm-assets__foot { margin-top:12px; padding:12px 15px; border:1px solid #19434a; border-radius:13px; color:#a5c0c5; font-size:12px; }
        .rm-assets__error { color:#ffd2d2; }
        @keyframes rmAssetAppear { from { opacity:0; transform:translateY(7px); } to { opacity:1; transform:translateY(0); } }
        @media(max-width:1100px) { .rm-assets__grid { grid-template-columns:repeat(3,minmax(0,1fr)); } }
        @media(max-width:760px) { .rm-assets__grid { grid-template-columns:repeat(2,minmax(0,1fr)); gap:8px; } .rm-assets__card { min-height:110px; padding:12px; gap:9px; } .rm-assets__icon { width:38px; height:38px; flex-basis:38px; font-size:16px; } .rm-assets__label { font-size:12px; } .rm-assets__head { padding:16px; } }
        @media(max-width:380px) { .rm-assets__card { flex-direction:column; align-items:flex-start; } .rm-assets__intro { align-items:flex-start; flex-direction:column; } }
        @media(prefers-reduced-motion:reduce) { .rm-assets__card { animation:none; transition:none; } }
      `}</style>
      <main className="rm-assets">
        <header className="rm-assets__head">
          <div>
            <p className="rm-assets__eyebrow">RM CROWN MARKET</p>
            <h1 className="rm-assets__heading">Asset Overview</h1>
            <p className="rm-assets__sub">Wallet, investment and income summary</p>
          </div>
          <div className="rm-assets__head-icon"><i className="fa-solid fa-chart-pie" aria-hidden="true" /></div>
        </header>
        <section className="rm-assets__intro" aria-label="Asset section heading">
          <strong>Financial Overview</strong><span>Wallet &amp; Income · {cards.length} Categories</span>
        </section>
        <section className="rm-assets__grid" aria-label="Asset values">
          {cards.map((item) => (
            <article className="rm-assets__card" key={item.key}>
              <div className="rm-assets__icon" aria-hidden="true">
                {item.image ? <img src={item.image} alt="" loading="lazy" /> : <i className={item.icon} />}
              </div>
              <div className="rm-assets__details">
                <p className="rm-assets__label">{item.title}</p>
                <p className="rm-assets__value">{item.value}</p>
              </div>
            </article>
          ))}
        </section>
        {apiError && <p className="rm-assets__foot rm-assets__error" role="alert">Unable to refresh asset information. Please try again later.</p>}
      </main>
    </>
  );
};

export default Home;
